export default __webpack_public_path__ + "static/Category3-8cb3306f46a0832ab593ed1cc7876ce7.jpg";